import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'

export default {
    getContractors({ commit }, payload = {
        paginate: '',
        query: ''}) {
        const paginate = payload.paginate,
            query = payload.query

        commit('GET_CONTRACTORS_REQUEST')

        return axios
            .get(`/outdoors/outdoor-localization-contractors${paginate}${query}`)
            .then(response => {
                commit('GET_CONTRACTORS_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_CONTRACTORS_FAILURE')
                handleApiError(error, 'Pobranie zleceniobiorców nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getContractor(context, id) {
        return axios
            .get(`/outdoors/outdoor-localization-contractors/${id}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, `Pobranie danych dla zleceniobiorcy ${id} nie powiodło się.`)

                return Promise.reject(error)
            })
    },
    createContractor({ commit }, payload) {
        return axios
            .post('/outdoors/outdoor-localization-contractors', payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Zleceniobiorca został dodany.'
                }, {root: true})

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Dodanie zleceniobiorcy nie powiodło się.')

                return Promise.reject(error)
            })
    },
    updateContractor({ commit }, payload) {
        return axios
            .put(`/outdoors/outdoor-localization-contractors/${payload.id}`, payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Zleceniobiorca został zedytowany.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Zapis nie powiódł się.')

                return Promise.reject(error)
            })
    },
    deleteContractor({ commit }, id) {
        return axios
            .delete(`/outdoors/outdoor-localization-contractors/${id}`)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Zleceniobiorca został usunięty.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Usunięcie zleceniobiorcy nie powiodło się.')

                return Promise.reject(error)
            })
    },
    setContractorFilters({ commit }, filters) {
        commit('SET_CONTRACTORS_FILTERS', filters)
    },
    clearContractorFilters({ commit }) {
        commit('CLEAR_CONTRACTORS_FILTERS')
    }
}